import * as React from "react";

const Pagination: React.FC = () => {
    return <svg width="122px" height="31px" viewBox="0 0 122 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="currentColor">
    
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-622.000000, -1142.000000)" stroke="#679D1F">
            <g transform="translate(16.000000, 794.000001)">
                <g transform="translate(606.000000, 347.999869)">
                    <rect x="0.5" y="0.5" width="121" height="30.0000844" rx="15.0000422"></rect>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Pagination);
